import React from "react";
import { AppBar, Box, Button, Container, Toolbar, Typography } from "@mui/material";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SettingsIcon from '@mui/icons-material/Settings';

const Header: React.FC = () => {
  return (
    <AppBar position="sticky" elevation={0}>
    <Container maxWidth="xl">
      <Toolbar sx={{ px: { xs: 0 }, height: 70 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            '& svg': { fontSize: 32, color: 'primary.second' }
          }}>
            <CloudUploadIcon />
            <Box>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: 600,
                  color: 'text.second',
                  lineHeight: 1.2
                }}
              >
                Excel/csv/text to e-conomic
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: 'text.second',
                  lineHeight: 1.2
                }}
              >
                Import Tool
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flex: 1 }} />

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              startIcon={<HelpOutlineIcon />}
              sx={{ color: 'text.secondary' }}
              onClick={() => {
                window.open('/excel-economic-docs.pdf', '_blank');
              }}
            >
              Help
            </Button>
            {/* <Button
              startIcon={<SettingsIcon />}
              sx={{ color: 'text.secondary' }}
            >
              Settings
            </Button> */}
          </Box>
        </Box>
      </Toolbar>
    </Container>
  </AppBar>
  );
};

export default Header;
